import { Box, Grid } from '@mui/material';
import { FC } from 'react';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from "./PublicFooter";
import {LoadingOverlay} from "../../../components";

export const PublicMainPageLayout: FC = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        position: 'relative',
        minHeight: '100%',
        backgroundColor: theme => theme.palette.background.default,
      }}
    >
      <LoadingOverlay />
      <Grid
        container
        direction="column"
        width="100%"
        sx={{ zIndex: 1, position: 'relative', minHeight: '100%' }}
      >
        <PublicHeader mode="dark" />

        <Grid item container direction="column" flex="1 0 auto">
          {children}
        </Grid>

        <PublicFooter />
      </Grid>
    </Box>
  );
};
